module.exports = __webpack_public_path__ + "static/media/historia-aparicion.9c1b1fcd.png";